module.exports = __webpack_public_path__ + "img/20220624162346.090fc703.png";